import React, { createContext, useContext, useState } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';

const ThemeContext = createContext();

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00F5FF',
    },
    secondary: {
      main: '#FF2E63',
    },
    background: {
      default: '#0F1624',
      paper: '#1A1D24',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#8F9BB7',
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#00D1D9',
    },
    secondary: {
      main: '#FF2E63',
    },
    background: {
      default: '#F5F7FA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A1D24',
      secondary: '#4A5568',
    },
  },
});

export function ThemeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(true);
  const theme = isDarkMode ? darkTheme : lightTheme;

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
